import { render, staticRenderFns } from "./Indicators.html?vue&type=template&id=202cb88a&scoped=true&"
import script from "./Indicators.js?vue&type=script&lang=js&"
export * from "./Indicators.js?vue&type=script&lang=js&"
import style0 from "./Indicators.scss?vue&type=style&index=0&id=202cb88a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202cb88a",
  null
  
)

export default component.exports